import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { createDeploymentLocationMaster, getAllDeploymentLocationMaster, getLocationById, updateDeploymentLocationMaster } from "../../Apis/deployLocationMasterApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { toast } from "react-toastify";
import { GetCircle, GetCirclebyID, GetWard, GetWardsbyCircleId, GetZone } from "../../Apis/organizationApi";
import { useForm } from "react-hook-form";
//import { GoogleMap, MarkerF, Circle, useLoadScript } from '@react-google-maps/api';
import { MapContainer, TileLayer, Marker, Circle, useMapEvents } from "react-leaflet";
import { useNavigate } from "react-router-dom";
import Loader from "../../Common/Loader/loader";
import { withTranslation } from "react-i18next";
import L from "leaflet";
import { AllCollectionTypeDetails } from "../../Apis/collectionTypeApi";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
import ExcelJS from "exceljs";
import { CorporationStore } from "../corporation_master/CorporationStore";
import TableSkeleton from "../AllotedMaster/TableSkeleton";

const DeploymentLocationMaster = ({ t }) => {
  const navigate = useNavigate();
  const { CorporationDetails, fetchCorporationDetails } = CorporationStore();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm()
  const [isEditMode, setIsEditMode] = useState(false);
  const [lgShow, setLgShow] = useState(false);
  const headers = ["DeploymentLocation", "landmark", "corporation", "zone", "circle", "ward", "radiusInMeters", "collectionType", "status", "actions"]
  const [locationData, setLocationData] = useState([]);
  const [editLocationData, setEditLocationData] = useState("");
  const center = {
    lat: 17.452555,
    lng: 78.3599819,
  };
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [formInput, setFormInput] = useState({
    zoneId: "",
    circleId: "",
    wardId: "",
    secondaryDeploymentLocationName: "",
    secondaryDeploymentLocationId: "",
    request: "",
    landmark: "",
    latitude: center.lat,
    longitude: center.lng,
    radiusInMeters: "",
    isActive: true,
    collectionTypeId: "",
    corporationId: "",
  });
  const [allZones, setAllZones] = useState([]);
  const [allCircles, setAllCircles] = useState([]);
  const [allWards, setAllWards] = useState([]);
  const [allZonesFull, setAllZonesFull] = useState([]); // Store full zone response for dictionaries
  const [allCirclesFull, setAllCirclesFull] = useState([]); // Store full circle response for dictionaries
  const [allWardsFull, setAllWardsFull] = useState([]); // Store full ward response for dictionaries
  const [circleFetchError, setCircleFetchError] = useState(null);
  const [selectedWard, setSelectedWard] = useState("");
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedCircles, setSelectedCircles] = useState([]);
  const [noCircles, setNoCircles] = useState(false);
  const [editLocationId, setEditLocationId] = useState(null);
  const [deploymentlocationData, setDeploymentLocationData] = useState()
  const [deploymentLocationLoading, setIsDeploymentDataLoading] = useState(true)
  const [loadingCircles, setLoadingCircles] = useState(false);
  const [loadingWards, setLoadingWards] = useState(false);
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [collectionTypeData, setCollectionTypeData] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null)
  const [selectedLocationCoordinates, setSelectedLocationCoordinates] = useState(center);
  const [radiusInMeters, setRadiusInMeters] = useState(0);
  const resetRef = useRef(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [filterOriginalDeploymentLocationData, setFilterOriginalDeploymentLocationData] = useState([]);

  let storedPermissions = localStorage.getItem('permissionId')
  const permissionValues1 = JSON.parse(localStorage.getItem('rolePermissions')) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  // Use this page's own permissionId so the Add/Update buttons don't depend on
  // the shared localStorage "permissionId" (which caused them to sometimes hide).
  storedPermissions = 14;

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(mapping => mapping.permissionId === storedPermissions);

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(`canWrite value for permission ID ${storedPermissions}:`, canWriteValue);
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }


  const resetFields = (reset) => {
    setFormInput({
      zoneId: "",
      circleId: "",
      wardId: "",
      secondaryDeploymentLocationId: "",
      secondaryDeploymentLocationName: "",
      landmark: "",
      collectionTypeId: "",
      corporationId: "",
      latitude: "",
      longitude: "",
      radiusInMeters: "",
      isActive: "",
    });
    resetRef.current();
  }

  useEffect(() => {
    resetRef.current = reset;
  }, [reset]);

  const fetchCollectionType = async () => {
    try {
      const response = await AllCollectionTypeDetails();
      if (response && response.length > 0) {
        setCollectionTypeData(response);
      } else {
        setCollectionTypeData([])
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleClose = () => {
    resetFields();
    setLgShow(false);
    setIsEditMode(false);
    setSelectedLocation(null);
    setFormSubmitted(false);
    if (!isEditMode) {
      setIsOptionsLoading(false);
    }
  }

  const handleEditLocation = async (selectedLocationData) => {
    setEditLocationData(selectedLocationData);
    setEditLocationId(selectedLocationData.id);
    setSelectedLocation(selectedLocationData);
    setLgShow(true);
    setIsOptionsLoading(true)
    const { circleId, wardId, zoneId } = selectedLocationData;
    setFormInput({
      ...formInput,
      zoneId,
      circleId,
      wardId,
      secondaryDeploymentLocationName: selectedLocationData.secondaryDeploymentLocationName,
      secondaryDeploymentLocationId: selectedLocationData.secondaryDeploymentLocationId,
      request: selectedLocationData.request,
      isActive: selectedLocationData.isActive,
      landmark: selectedLocationData.landmark,
      collectionTypeId: selectedLocationData.collectionTypeId,
      corporationId: selectedLocationData.corporationId,
      latitude: selectedLocationData.latitude,
      longitude: selectedLocationData.longitude,
      radiusInMeters: selectedLocationData.radiusInMeters,
    });
    try {
      const circlesData = await GetCirclebyID(zoneId);
      setAllCircles(circlesData);
      const wardsData = await GetWardsbyCircleId(circleId);
      setAllWards(wardsData);
    } catch (error) {
      console.error("Error fetching circles and wards data:", error);
    }
    reset();
    setIsOptionsLoading(false)
  };


  const fetchLocation = async () => {
    setIsDeploymentDataLoading(true);
    try {
      const locationResponse = await getAllDeploymentLocationMaster();
      if (!locationResponse) {
        console.error("location response is undefined:", locationResponse);
        return [];
      }
      const locationData = locationResponse;
      
      // Use stored full responses to build dictionaries (no API calls here)
      const zoneNamesDictionary = {};
      allZonesFull.forEach(zone => {
        zoneNamesDictionary[zone.zoneId] = zone.zoneName;
      });
      const circleNamesDictionary = {};
      allCirclesFull.forEach(circle => {
        circleNamesDictionary[circle.circleId] = circle.circleName;
      });
      const wardNamesDictionary = {};
      allWardsFull.forEach(ward => {
        wardNamesDictionary[ward.wardId] = ward.wardName;
      });
      const collectionTypeNamesDictionary = {};
      collectionTypeData.forEach(collectionType => {
        collectionTypeNamesDictionary[collectionType.collectionTypeId] = collectionType.collectionTypeName;
      });
      const corporationNamesDictionary = {};
      CorporationDetails.forEach(corp => {
        corporationNamesDictionary[corp.corporationId] = corp.corporationName;
      });
      const mappedLocationData = locationData.map(location => ({
        ...location,
        zone: zoneNamesDictionary[location.zoneId] || location.zoneName || "N/A",
        circle: circleNamesDictionary[location.circleId] || location.circleName || "N/A",
        ward: wardNamesDictionary[location.wardId] || location.wardName || "N/A",
        collectionType: collectionTypeNamesDictionary[location.collectionTypeId] || location.collectionTypeName || "N/A",
        corporation: corporationNamesDictionary[location.corporationId] || location.corporationName || "N/A",
        DeploymentLocation: location.secondaryDeploymentLocationName,
        status: location.isActive ? "Active" : "InActive",
        radiusinMeters: location.radiusInMeters
      }));

      // Sort the data based on the isActive field
      const sortedLocationData = mappedLocationData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });
      setLocationData(sortedLocationData);
      setOriginalData(mappedLocationData);
      setFilterOriginalDeploymentLocationData(mappedLocationData);
      // setLocationData(mappedLocationData);


      setIsDeploymentDataLoading(false);
      return mappedLocationData;
    } catch (error) {
      console.error("Error fetching  deploymentlocation data:", error);
      throw error;
    }
  };

  const addNewLocation = async (data) => {
    try {
      setFormSubmitted(true);
      setIsOptionsLoading(true)
      await new Promise(resolve => setTimeout(resolve, 1000));
      // const zoneId = data.zoneId || ''
      // const circleId = data.circleId || ''
      // const wardId = data.wardId || ''
      // const secondaryDeploymentLocationName = data.secondaryDeploymentLocationName || ''
      // const landmark = data.landmark || ""
      // const collectionTypeId = data.collectionTypeId || ""
      // const latitude = data.latitude || ""
      // const longitude = data.longitude || ""
      // const radiusInMeters = data.radiusInMeters || ""
      // const secondaryDeploymentLocationId = data.secondaryDeploymentLocationId || ""
      // // const isActive = data.isActive || true
      // const isActive = data.isActive || '';
      // // const isActive = selectedLocation ? formInput.isActive : true;


      if (
        !formInput.secondaryDeploymentLocationName
        || !formInput.landmark
        || !formInput.corporationId
        || !formInput.zoneId
        || !formInput.circleId
        || !formInput.wardId
        || !formInput.collectionTypeId
        || !formInput.latitude
        || !formInput.longitude
        || !formInput.radiusInMeters
        // || !formInput.isActive
      ) {
        // Display toast message indicating the required field
        // toast.error("Please fill out all required fields", {
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        // });
        // Stop further execution
        return;
      }
      const {
        zoneId,
        circleId,
        wardId,
        secondaryDeploymentLocationName,
        landmark,
        collectionTypeId,
        corporationId,
        latitude,
        longitude,
        radiusInMeters,
        isActive,
        secondaryDeploymentLocationId,
      } = formInput;
      const requestData = {
        zoneId,
        circleId,
        wardId,
        secondaryDeploymentLocationName,
        landmark,
        collectionTypeId,
        corporationId,
        latitude,
        longitude,
        radiusInMeters,
        isActive,
        secondaryDeploymentLocationId,
      }
      if (selectedLocation) {
        const res = await updateDeploymentLocationMaster(selectedLocation.secondaryDeploymentLocationId, requestData)

        const successMessage = 'Deployment Location Updated Successfully!'
        toast.success(successMessage, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        fetchLocation();
        reset();
        handleClose();
      } else {
        const res = await createDeploymentLocationMaster(requestData);
        const successMessage = 'Deployment Location Added Successfully!'
        toast.success(successMessage, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        reset();
        fetchLocation();
        handleClose();
      }
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          // Handle 400 status code errors with validation errors
          const validationErrors = data;
          // for (const field in validationErrors) {
          toast.error(validationErrors, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
          // }
        } else if (status === 409) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 404) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } else {
        // Handle network errors or other unexpected errors
        toast.error("An error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
    } finally {
      setIsOptionsLoading(false);
    }
  }

  const handleKeyDown = (event, callback) => {
    if (event.key === 'Enter' && event.shiftKey === false) {
      event.preventDefault()
      callback(addNewLocation)
    }
  }

  const fetchCirclesData = async (zoneId) => {
    try {
      const response = await GetCirclebyID(zoneId);
      setAllCircles(response);
      setNoCircles(response.length === 0);
      setCircleFetchError(null);
    } catch (error) {
      console.error("Error fetching circles data:", error);
      setAllCircles([]);
      setNoCircles(true);
      setCircleFetchError(
        error.response ? error.response.message : "Unknown error occurred"
      );
      // toast.error(`Error fetching circles: ${circleFetchError}`);
    }
  };

  const handleZoneChange = async (zoneId) => {
    setFormInput((prevData) => ({
      ...prevData,
      zoneId: zoneId,
      circleId: "",
      wardId: "",
    }));
    setSelectedCircles("");
    setSelectedWard("");
    fetchCirclesData(zoneId);
  };

  const handleCircleChange = async (circleId) => {
    setFormInput((prevData) => ({
      ...prevData,
      circleId: circleId,
      wardId: "",
    }));
    setSelectedWard("");
    try {
      const wardsData = await GetWardsbyCircleId(circleId);
      setAllWards(wardsData);
    } catch (error) {
      console.error("Error fetching wards data:", error);
    }
  };

  const fetchCirclesAndWards = async (zoneId) => {
    try {
      const circlesData = await GetCirclebyID(zoneId);
      setAllCircles(circlesData);
      setSelectedCircles([]);
      setCircleFetchError(null);
      setNoCircles(false);
    } catch (error) {
      console.error("Error fetching circles data:", error);
      setCircleFetchError("Error fetching circles data");
      setAllCircles([]);
      setNoCircles(false);
      setAllWards([]);
    }
  };

  const fetchAllDataDetails = async () => {
    setIsOptionsLoading(true)
    try {
      // Call GetZone, GetCircle, GetWard only once here
      const zonesData = await GetZone();
      const circlesData = await GetCircle();
      const wardsData = await GetWard();
      
      // Store full responses for building dictionaries
      setAllZonesFull(zonesData);
      setAllCirclesFull(circlesData);
      setAllWardsFull(wardsData);
      
      // Store filtered active values for dropdowns
      const zoneTrueValues = zonesData.filter(item => item.isActive === true);
      setAllZones(zoneTrueValues);
      const circleTrueValues = circlesData.filter(item => item.isActive === true);
      setAllCircles(circleTrueValues);
      const wardTrueValues = wardsData.filter(item => item.isActive === true);
      setAllWards(wardTrueValues);
      
      if (selectedZone) {
        const circlesDataByZone = await GetCirclebyID(selectedZone);
        setAllCircles(circlesDataByZone);
        setSelectedCircles([]);
      }
      if (selectedZone) {
        const wardsDataByZone = await GetWardsbyCircleId(selectedZone);
        setAllWards(wardsDataByZone);
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      await fetchAllDataDetails(); // Wait for zones, circles, wards to load
      await fetchCollectionType(); // Wait for collection types to load
      await fetchCorporationDetails(); // Wait for corporations to load
      fetchLocation(); // Then fetch location data which uses the loaded data
      if (editLocationId) {
        fetchCirclesAndWards(editLocationData.zoneId);
        setSelectedLocationCoordinates({
          lat: parseFloat(editLocationData.latitude),
          lng: parseFloat(editLocationData.longitude),
        });
      }
    };
    initializeData();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // map
  // const handleMapClick = (e) => {
  //   const lat = e.latLng.lat();
  //   const lng = e.latLng.lng();

  //   // Update the selected location coordinates
  //   setSelectedLocationCoordinates({ lat, lng });
  //   setFormInput({ ...formInput, latitude: lat, longitude: lng });
  //   // Update the form input values
  //   setValue('latitude', lat);
  //   setValue('longitude', lng);
  // };


  const handleMapClick = (e) => {
    const { lat, lng } = e.latlng;
    setSelectedLocationCoordinates({ lat, lng });
    setFormInput({ ...formInput, latitude: lat, longitude: lng });
    setValue('latitude', lat);
    setValue('longitude', lng);
  };

  const MapEvents = () => {
    useMapEvents({
      click: handleMapClick,
    });
    return null;
  };

  // const handleMapChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormInput({ ...formInput, [name]: value });

  //   if (name === 'latitude' || name === 'longitude') {
  //     const lat = name === 'latitude' && value !== ""  ? parseFloat(value) : parseFloat(formInput.latitude);
  //     const lng = name === 'longitude' && value !== "" ? parseFloat(value) : parseFloat(formInput.longitude);

      
  //     if (value === "") {
  //       setSelectedLocationCoordinates({ lat: "", lng: "" }); // Reset when empty
  //     } else if (!isNaN(lat) && !isNaN(lng)) {
  //       setSelectedLocationCoordinates({ lat, lng });
  //     }
  //   }
  // };

  const handleMapChange = (e) => {
    const { name, value } = e.target;
  
    // Regular expression to check for valid number (allowing only digits and one decimal point)
    const validNumberRegex = /^-?\d*\.?\d*$/;
  
    // Check if the value is a valid number or empty
    if (validNumberRegex.test(value) || value === "") {
      setFormInput({ ...formInput, [name]: value });
      setValue(name, value, { shouldValidate: true });
  
      if (name === "latitude" || name === "longitude") {
        const lat =
          name === "latitude" && value !== "" ? parseFloat(value) : formInput.latitude;
        const lng =
          name === "longitude" && value !== "" ? parseFloat(value) : formInput.longitude;
  
        if (value === "") {
          setSelectedLocationCoordinates({ lat: "", lng: "" }); // Reset when empty
        } else if (!isNaN(lat) && !isNaN(lng)) {
          setSelectedLocationCoordinates({ lat, lng });
        }
      }
    }
  };

  const validateLatitudeRequired = (value) => {
    if (!value || value === "") {
      return "Latitude is required";
    }
    const numValue = parseFloat(value);
    if (isNaN(numValue) || !value.includes(".")) {
      return "Latitude must contain a decimal value";
    }
    if (numValue < -90.0 || numValue > 90.0) {
      return "Latitude must be between -90.0 and 90.0";
    }
    return true;
  };

  const validateLongitudeRequired = (value) => {
    if (!value || value === "") {
      return "Longitude is required";
    }
    const numValue = parseFloat(value);
    if (isNaN(numValue) || !value.includes(".")) {
      return "Longitude must contain a decimal value";
    }
    if (numValue < -180.0 || numValue > 180.0) {
      return "Longitude must be between -180.0 and 180.0";
    }
    return true;
  };

  const handleShow = () => {
    setLgShow(true);
    setIsOptionsLoading(true);
    setFormInput({
      zoneId: "",
      circleId: "",
      wardId: "",
      secondaryDeploymentLocationName: "",
      secondaryDeploymentLocationId: "",
      request: "",
      landmark: "",
      latitude: 17.452555,
      longitude: 78.3599819,
      radiusInMeters: "",
      isActive: true,
      collectionTypeId: "",
      corporationId: "",
    })
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
  }

  // const handleStatusChange = (e) => {
  //   const statusValue = e.target.id === "activeRadio" ? 1 : 2;
  //   setFormInput((prevData) => ({
  //     ...prevData,
  //     status: statusValue,
  //   }));
  // };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      // [name]: value === "true" ? true : false,
      [name]: value === "true",
    }));
  };

  const handleViewLocationData = async (id) => {
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setIsOptionsLoading(true)
      const response = await getLocationById(id);
      const locationDetails = response.data;
      navigate("/deployment-location-details", { state: { locationDetails } });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false)
    }
  };

  // const customMarkerIcon = {
  //   url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAw8Jfpzq4fp1vFbIILJHCdRI1WKWxMJatng&usqp=CAU",
  //   scaledSize: new window.google.maps.Size(30, 30), // Adjust the size as needed
  // };

  const customMarkerIcon = L.icon({
    iconUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAw8Jfpzq4fp1vFbIILJHCdRI1WKWxMJatng&usqp=CAU",
    iconSize: [30, 30],
  });
  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const dataToUse = sortedData.length > 0 ? sortedData : originalData;
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1
      }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Deployment Location Details`;
    const downloadDateTime = `Deployment Location Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 10); // Merge cells for downloadDateTime
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 10; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    worksheet.addRow(["", "", "Deployment Location Details", ""]);
    worksheet.mergeCells(2, 2, 2, 10);
    worksheet.getCell(2, 2).value = "Deployment Location Details";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 10; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }


    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Deployment Location",
      "Landmark",
      "Corporation",
      "Zone",
      "Circle",
      "Ward",
      "Radius In Meters",
      "CollectionType",
      "Status"
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 11) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }
        };
      }
    });

    // Add data rows
    dataToUse.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.secondaryDeploymentLocationName,
        item.landmark,
        item.corporation,
        item.zone,
        item.circle,
        item.ward,
        item.radiusInMeters,
        item.collectionType,
        item.status
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 11) {
          cell.alignment = { horizontal: "left" };
        } else {
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    worksheet.columns = [
      { width: 5 },
      { width: 35 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "DeploymentLocationDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  // const { isLoaded, loadError } = useLoadScript({
  //   googleMapsApiKey: "AIzaSyAm9ekbF8SnmFeUH4BvEffHYu_TuUieoDw", // Replace with your Google Maps API key
  // });
  // if (!isLoaded) return "Loading maps...";

  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...locationData].sort((a, b) => {
      if (sortConfig.order === 'asc') {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };

  const searchDeploymentLocationHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalDeploymentLocationData.filter(item => item?.secondaryDeploymentLocationName?.toLowerCase()?.includes(term));
    setLocationData(data);
  }

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="row justify-content-between">
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      placeholder="Search Deployment Location"
                      type="text"
                      className="form-control bg-white"
                      onInput={searchDeploymentLocationHandler}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="flex_end_middle mb-3">
                    {canWriteValue === true ?
                      <button className="button-container" onClick={handleShow}>
                        <i className="fa-solid fa-plus me-1 icon-container"></i>
                        {t("addDeployment")}

                      </button>
                      : ''}

                    <button className="btn btn-excel"
                      onClick={handleSortAndExport}>
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                    </button>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="top-header">
                    <span >{t("Deployment Location Details")}</span>
                  </div>
                  {deploymentLocationLoading ? <TableSkeleton /> : <TableComponent
                    DataFetchURL={locationData}
                    headers={headers}
                    filterFunction={(data) =>
                      data.filter(
                        (item) => item.status === 1 || item.status === 0
                      )
                    }
                    editData={handleEditLocation}
                    editLocationData={editLocationData}
                    viewData={(id) => handleViewLocationData(id)}
                    onSort={handleSort}
                    skipGetCircle={true}
                  />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {selectedLocation ? "Edit Deployment Location" : "Add Deployment Location"}
          </Modal.Title>
          <i class="fa-solid fa-xmark close-container" onClick={handleClose}></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form
            onSubmit={handleSubmit(addNewLocation)}
            onKeyDown={(e) => {
              handleKeyDown(e, handleSubmit)
            }}
          >
            <div className="row">
              {/* {selectedLocation ? */}
              <div className="col-md-4 " style={{ display: 'none' }}>
                <div className="form-group">
                  <label className="form-label">ID</label>
                  <input
                    type="number"
                    className="form-control"
                    name="secondaryDeploymentLocationId"
                    {...register('secondaryDeploymentLocationId')}
                    value={formInput.secondaryDeploymentLocationId}
                    readOnly
                    onChange={(e) => setFormInput({ ...formInput, secondaryDeploymentLocationId: e.target.value })}
                    disabled={!canWriteValue}
                  />
                </div>
              </div>
              {/* :
                ''
              } */}
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Deployment Location<span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="text"
                    placeholder="Enter Deployment Location Name"
                    className={`form-control ${formInput.secondaryDeploymentLocationName || !formSubmitted ? "" : "input-error"
                      }`}
                    name="secondaryDeploymentLocationName"
                    {...register('secondaryDeploymentLocationName')}
                    value={formInput.secondaryDeploymentLocationName}
                    onChange={(e) => {
                      const value = e.target.value.replace(/^\s+/, "").replace(/\s{2,}/g, " "); // Remove leading spaces & multiple spaces
                      setFormInput({ ...formInput, secondaryDeploymentLocationName: value });
                    }}
                    maxLength={40}
                    disabled={!canWriteValue}
                  />
                  {!formInput.secondaryDeploymentLocationName && formSubmitted && (
                    <div className="required-message">
                      Deployment Location is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Corporation <span style={{ color: '#EC1117' }}> *</span></label>
                  <select
                    value={formInput.corporationId}
                    {...register('corporationId')}
                    name="corporationId"
                    className={`form-select ${formInput.corporationId || !formSubmitted ? "" : "input-error"}`}
                    onChange={(e) =>
                      setFormInput((prevData) => ({
                        ...prevData,
                        corporationId: e.target.value,
                        zoneId: "",
                        circleId: "",
                        wardId: "",
                      }))
                    }
                    disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {CorporationDetails.filter(c => c.isActive).map((corp) => (
                      <option key={corp.corporationId} value={corp.corporationId}>
                        {corp.corporationName}
                      </option>
                    ))}
                  </select>
                  {!formInput.corporationId && formSubmitted && (
                    <div className="required-message">Corporation is Required</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Landmark <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="text"
                    placeholder="Enter Landmark"
                    maxLength={200}
                    className={`form-control ${formInput.landmark || !formSubmitted ? "" : "input-error"
                      }`}
                    name="landmark"
                    {...register('landmark')}
                    value={formInput.landmark}
                    onChange={(e) => {
                      const value = e.target.value.replace(/^\s+/, "").replace(/\s{2,}/g, " "); // Remove leading spaces & multiple spaces
                      setFormInput({ ...formInput, landmark: value });
                    }}
                    disabled={!canWriteValue}
                  />
                  {!formInput.landmark && formSubmitted && (
                    <div className="required-message">
                      LandMark is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Collection Type <span style={{ color: '#EC1117' }}> *</span></label>
                  <select
                    value={formInput.collectionTypeId}
                    {...register('collectionTypeId')}
                    name="collectionTypeId"
                    className={`form-select ${formInput.collectionTypeId || !formSubmitted ? "" : "input-error"
                      }`}
                    onChange={(e) => {
                      setFormInput({
                        ...formInput,
                        collectionTypeId: e.target.value,
                      });
                    }}
                    disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {collectionTypeData.map((collection) => (
                      <option key={collection.collectionTypeId} value={collection.collectionTypeId}>
                        {collection.collectionTypeName}
                      </option>
                    ))}
                  </select>
                  {!formInput.collectionTypeId && formSubmitted && (
                    <div className="required-message">
                      Collection Type is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Zone <span style={{ color: '#EC1117' }}> *</span></label>
                  <select
                    value={formInput.zoneId}
                    {...register('zoneId')}
                    name="zoneId"
                    className={`form-select ${formInput.zoneId || !formSubmitted ? "" : "input-error"
                      }`}
                    onChange={(e) => {
                      const selectedZoneId = e.target.value;
                      setFormInput((prevData) => ({
                        ...prevData,
                        zoneId: selectedZoneId,
                        circleId: "", // Reset circle and ward when zone changes
                        wardId: "",
                      }));
                      setSelectedZone(selectedZoneId);
                      if (selectedZoneId) {
                        fetchCirclesAndWards(selectedZoneId);
                      }
                      handleZoneChange(e.target.value);
                    }}
                    disabled={!formInput.corporationId || !canWriteValue}
                  >
                    <option value="">Select</option>
                    {allZones
                      ?.filter(
                        (zone) =>
                          zone.isActive &&
                          String(zone.corporationId) === String(formInput.corporationId),
                      )
                      .map((zone) => (
                        <option key={zone.zoneId} value={zone.zoneId}>
                          {zone.zoneName}
                        </option>
                      ))}
                  </select>
                  {!formInput.zoneId && formSubmitted && (
                    <div className="required-message">
                      Zone is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Circle <span style={{ color: '#EC1117' }}> *</span></label>
                  <select
                    value={formInput.circleId}
                    name="circleId"
                    className={`form-select ${formInput.circleId || !formSubmitted ? "" : "input-error"
                      }`}
                    {...register('circleId')}
                    onChange={(e) => {
                      setFormInput((prevData) => ({
                        ...prevData,
                        circleId: e.target.value,
                        wardId: "",
                      }));
                      handleCircleChange(e.target.value);
                    }}
                    // disabled={!formInput.zoneId}
                    disabled={!formInput.zoneId || !canWriteValue}
                  >
                    <option value="">Select</option>
                    {loadingCircles && <option disabled>Loading circles...</option>}
                    {Array.isArray(allCircles) && !loadingCircles &&
                      allCircles.filter((circle) => circle.isActive)
                        .map((circle) => (
                          <option
                            key={circle.circleId}
                            value={circle.circleId}
                          >
                            {circle.circleName}
                          </option>
                        ))}
                  </select>
                  {!formInput.circleId && formSubmitted && (
                    <div className="required-message">
                      Circle is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Ward <span style={{ color: '#EC1117' }}> *</span></label>
                  <select
                    value={formInput.wardId}
                    name="wardId"
                    className={`form-select ${formInput.wardId || !formSubmitted ? "" : "input-error"
                      }`}
                    {...register('wardId')}
                    onChange={(e) => {
                      setFormInput((prevData) => ({
                        ...prevData,
                        wardId: e.target.value,
                      }));
                    }}
                    // disabled={!formInput.circleId}
                    disabled={!formInput.circleId || !canWriteValue}
                  >
                    <option value="">Select</option>
                    {loadingWards && <option disabled>Loading Wards...</option>}
                    {Array.isArray(allWards) &&
                      allWards.filter((ward) => ward.isActive)
                        .map((ward) => (
                          <option key={ward.wardId} value={ward.wardId}>
                            {ward.wardName}
                          </option>
                        ))}
                  </select>
                  {!formInput.wardId && formSubmitted && (
                    <div className="required-message">
                      Ward is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Latitude <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="text"
                    className="form-control"
                    name="latitude"
                    value={formInput.latitude || selectedLocationCoordinates.lat}
                    {...register("latitude", {
                      required: "Latitude is Required",
                      validate: validateLatitudeRequired, // Custom validation for latitude
                    })}
                    onChange={handleMapChange}
                    disabled={!canWriteValue}
                  />
                  {errors.latitude && (
                   <div className="required-message">{errors.latitude.message}</div>
                 )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Longitude <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="text"
                    className="form-control"
                    name="longitude"
                    {...register("longitude", {
                      required: "Longitude is Required",
                      validate: validateLongitudeRequired, // Custom validation for longitude
                    })}
                    value={formInput.longitude || selectedLocationCoordinates.lng}
                    onChange={handleMapChange}
                    disabled={!canWriteValue}
                  />
                  {errors.longitude && (
                   <div className="required-message">{errors.longitude.message}</div>
                 )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Radius in Meters <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    min={0}
                    type="number"
                    placeholder="Enter radius in Meters"
                    className={`form-control ${formInput.radiusInMeters || !formSubmitted ? "" : "input-error"
                      }`}
                    name="radiusInMeters"
                    {...register('radiusInMeters')}
                    value={formInput.radiusInMeters}
                    onChange={(e) => {
                      if (e.target.value.length <= 6) { // Restrict to 40 digits
                        const value = e.target.value.replace(/[^0-9.]/g, ""); // Remove invalid characters
                        setRadiusInMeters(parseFloat(value));
                        setFormInput({ ...formInput, radiusInMeters: value });
                      }
                    }}
                    disabled={!canWriteValue}
                  />
                  {!formInput.radiusInMeters && formSubmitted && (
                    <div className="required-message">
                      Radius in Meters is Required
                    </div>
                  )}
                </div>
              </div>
              {/* {selectedLocation ? ( */}
              <div className="col-md-4 mt-2">
                <label className="form-label">Status <span style={{ color: '#EC1117' }}> *</span></label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="activeRadio"
                      {...register('isActive')}
                      value="true"
                      checked={formInput.isActive === true}
                      // onChange={() =>
                      //   setFormInput({ ...formInput, isActive: "1" })
                      // }
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "60px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="inactiveRadio"
                      {...register('isActive')}
                      value="false"
                      checked={formInput.isActive === false}
                      // onChange={() =>
                      //   setFormInput({ ...formInput, isActive: "0" })
                      // }
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="inactiveRadio">
                      InActive
                    </label>
                  </div>
                </div>
              </div>
              {/* ) : (
                ""
              )} */}
              <div className="col-md-12">
                <div className="form-group">
                  <label className="form-label">Map</label>
                  {/* <LoadScript googleMapsApiKey="AIzaSyAm9ekbF8SnmFeUH4BvEffHYu_TuUieoDw"> */}
                  {/* <GoogleMap
                    mapContainerStyle={{ height: '400px', width: '100%' }}
                    center={selectedLocationCoordinates}
                    zoom={14}
                    onClick={handleMapClick}
                  >
                    {typeof window !== 'undefined' && window.google && (
                      <>
                        <MarkerF
                          position={selectedLocationCoordinates}
                          icon={customMarkerIcon}
                        />
                        {radiusInMeters > 0 && (
                          <Circle
                            center={selectedLocationCoordinates}
                            radiusInMeters={radiusInMeters * 1}
                            options={{
                              strokeColor: '#FF0000',
                              strokeOpacity: 0.8,
                              strokeWeight: 2,
                              fillColor: '#FF0000',
                              fillOpacity: 0.35,
                            }}
                          />
                        )}
                      </>
                    )}
                  </GoogleMap> */}

                  <MapContainer
                    center={selectedLocationCoordinates}
                    zoom={14}
                    style={{ height: "400px", width: "100%" }}
                  >
                    <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker
                      position={selectedLocationCoordinates}
                      icon={customMarkerIcon}
                    />
                    <MapEvents />
                  </MapContainer>
                  {/* </LoadScript> */}
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              {canWriteValue === true ?
                <button
                  type="submit"
                  className="deployment-button"
                >
                  <i class="fa-solid fa-check done-container"></i>
                  {selectedLocation ? t("Update") : t("Save")}
                </button>
                : ''}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(DeploymentLocationMaster);